import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule, ModalController } from '@ionic/angular';

import { SUPPORT_STEP_ASSIGNEE_TYPES } from 'src/app/constants';
import { ConversationsService } from 'src/services/conversations.service';
import { MessageService } from 'src/services/message.service';
import { SearchablePopoverService } from 'src/services/searchable-popover.service';

@Component({
  selector: 'app-approval-request',
  templateUrl: './approval-request.component.html',
  styleUrls: ['./approval-request.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, RouterModule],
})
export class ApprovalRequestComponent {
  conversationId: string;
  title: string;
  assignedToId: string;
  assignedToType: string;
  assignedToName: string;
  isLoading = false;

  constructor(
    private conversationsService: ConversationsService,
    private searchablePopoverService: SearchablePopoverService,
    private msgService: MessageService,
    private modalCtrl: ModalController,
  ) {}

  dismiss() {
    this.modalCtrl.dismiss();
  }

  async submit() {
    this.isLoading = true;

    try {
      const approvalRequest = await this.conversationsService.createApprovalRequest(this.conversationId, {
        title: this.title,
        assignedToGroupId: this.assignedToType !== SUPPORT_STEP_ASSIGNEE_TYPES.USER ? this.assignedToId : undefined,
        assignedToUserId: this.assignedToType === SUPPORT_STEP_ASSIGNEE_TYPES.USER ? this.assignedToId : undefined,
      });

      this.isLoading = false;
      this.modalCtrl.dismiss({ approvalRequest });
    } catch (e) {
      this.msgService.showError(e);
      this.isLoading = false;
    }
  }

  showAssigneeOptions() {
    this.searchablePopoverService.assignees({
      event,
      showCreatedByUserOption: false,
      showPrimaryRepOption: false,
      showNoneOption: false,
      selectedId: this.assignedToId,
      callback: async (id: string, name: string, object: any) => {
        this.assignedToId = id;
        this.assignedToName = name;
        this.assignedToType = object?.type ?? SUPPORT_STEP_ASSIGNEE_TYPES.USER;
      },
    });
  }
}
